import DOMPurify from 'dompurify';
import { marked } from 'marked';
import React from 'react';

export const Markdown = ({ markdown }: { markdown: string }) => {
  const html = DOMPurify.sanitize(marked.parse(markdown, { async: false }));
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};
